import React from 'react'

function Spinner (props) {

  return (
    <div className={'spinner'}
         style={props.color ? { borderColor: props.color, borderBottomColor: 'transparent' } : {}}/>
  )
}

export default Spinner